import type { HabitRecord, UserSettings } from './types.js';
import { getState } from './state.js';

/**
 * Return a habit's display label honoring the user's privacyMode setting.
 * When privacy mode is on, surfaces show a neutral "Plan" placeholder so
 * habit names are not visible to anyone looking over the user's shoulder.
 */
export function habitDisplayLabel(
  habit: HabitRecord,
  settings: UserSettings = getState().settings,
): string {
  if (settings.privacyMode) return 'Plan';
  return habit.privateLabel ?? habit.label;
}
